import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ColumnHeader from './ColumnHeader';
import Database from '../../controllers/Database';
import { PlusIcon } from '../../../Icons';
import generateKey from '../../utils/generateKey';
import { DATABASE_ADD_COLUMN } from '../../../../types/AnalyticsTypes';

function ColumnsRow(_ref) {
  var database = _ref.database,
      sort = _ref.sort;
  var columns = database.getSortedColumns();
  var ref = React.useRef();

  function createColumn(event) {
    event.stopPropagation();
    var key = generateKey();
    database.insertColumn({
      key: key
    }).registerScrollColumnKey(key).command('track', DATABASE_ADD_COLUMN, {
      source: 'Click plus icon'
    });
  }

  function isSorted(columnKey) {
    return sort && sort.columnKey === columnKey;
  }

  return React.createElement("thead", null, React.createElement("tr", {
    "data-qa": "database-columns-row"
  }, columns.map(function (column) {
    return React.createElement(ColumnHeader, {
      key: column.key,
      database: database,
      readOnly: database.readOnly,
      column: column,
      isSelected: database.isSelected('header', column.key),
      isFocused: !!database.isFocused('header', column.key),
      isActive: database.isActive('header', column.key),
      sort: isSorted(column.key) ? sort : null,
      columnCount: columns.length
    });
  }), !database.readOnly && React.createElement("td", {
    className: "slite-editor-database-cell"
  }, React.createElement("div", {
    ref: ref,
    "data-qa": "database-columns-new",
    onClick: createColumn,
    style: {
      width: 32,
      height: 32,
      lineHeight: 0
    },
    className: classNames('inline-block pointer', 'transition', 'padding-horizontal-small padding-vertical-normal radius-normal', 'shade-30 shade-10-on-hover')
  }, React.createElement(PlusIcon, null)))));
}

ColumnsRow.propTypes = {
  database: PropTypes.instanceOf(Database),
  columns: PropTypes.object.isRequired,
  sort: PropTypes.object
};
export default React.memo(ColumnsRow);